export default "__VITE_ASSET__4e5a8517__"